import React from 'react';
import * as css from './LecturerCardSkeleton.css';

interface LecturerCardSkeletonProps {
    variant?: 'active' | 'previous';
}

function LecturerCardSkeleton({variant = 'active'}: LecturerCardSkeletonProps) {
    const isPrevious = variant === 'previous';
    return (
        <css.card $previous={isPrevious} data-cy="lecturer-card-skeleton">
            <css.avatar $previous={isPrevious} />
            <css.line />
            <css.line $short />
            {!isPrevious && <css.footer />}
        </css.card>
    );
}

export default LecturerCardSkeleton;
